




import AnimationResponse from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/AnimationService/AnimationResponse";
import { Component, Vue, Prop, Model, Watch } from "vue-property-decorator";

//компонент "обертка" для удобного использования ui-dropdown
@Component
export default class UiAnimationDropdownComponent extends Vue {
  @Model('onSelected', {type: String, default: null}) value: string;
  innerValue: string = null;
  animations: AnimationResponse[] = [];
  noAnimation: AnimationResponse = {
    Id: null,
    Name: 'не выбрано',
    Url: null
  };
  @Watch('value')
  onValueChanged() {
    this.innerValue = this.value;
  }
  @Watch('innerValue')
  onInnerValueChanged() {
    this.$emit('onSelected', this.innerValue);
    this.$emit('onAnimationChoose', this.animations.find(x=>x.Id == this.innerValue));  
  }
  async created() {
    this.innerValue = this.value;
    const res = await this.$api.AnimationService.getAnimationsAsync();
    this.animations = res;
  }
}
